import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SeatsDesktopScreen from './desktop/SeatsDesktopScreen';
import SeatsMobileScreen from './mobile/SeatsMobileScreen';
import FlightsScreenController from '../flights/FlightsScreenController';
import RoutesSwitchController from '../../components/flights/routesSwitch/RoutesSwitchController';
import ProgressBarCenter from '../../components/ProgressBarCenter';
import ScreenDetection from '../../components/ScreenDetection';

/**
 * ## Redux imports
 */
import * as globalActions from '../../redux/actions/GlobalActions';
import * as routesActions from '../../redux/actions/RoutesActions';
import * as flightsActions from '../../redux/actions/FlightsActions';
import * as allFlightsActions from '../../redux/actions/AllFlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';
import SeatsScreenController from './SeatsScreenController';
import Navigation from '../../components/navigation/Navigation';
import Constants from '../../model/AppConfiguration';

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions, routesActions, flightsActions, allFlightsActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    general: selectors.general.getAll(state.general),
    reservationId: selectors.general.getReservationId(state.general),
    activePassenger: selectors.global.activePassenger(state.global),
    routes: selectors.routes.getRoutes(state.routes),
    flights: selectors.flights.getFlights(state.flights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class SeatsScreen extends Component {
  static propTypes = {
    actions: PropTypes.object,
    isFetching: PropTypes.bool,
    activePassenger: PropTypes.string,
    flights: PropTypes.arrayOf(PropTypes.object),
    routes: PropTypes.arrayOf(PropTypes.object),
  };

  constructor (props) {
    super(props);

    this.findRouteById = FlightsScreenController.findRouteById.bind(this);
    this.findTripByRoute = FlightsScreenController.findTripByRoute.bind(this);
    this.toggleRoutes = RoutesSwitchController.toggleRoutes.bind(this);
    this.openEditPassenger = SeatsScreenController.openEditPassenger.bind(this);
    this.closeEditPassenger = SeatsScreenController.closeEditPassenger.bind(this);
    let trips = [ { id: '1', label: 'One Way' }, { id: '2', label: 'Round Trip' } ];

    this.state = {
      selectedRoute: null,
      selectedTrip: trips[ 0 ],
      trips: trips,
      editOpened: false,
      submitData: null,
    };

    props.actions.getFlights(Constants.REQUEST.SEATS, props.reservationId);
  }

  componentWillReceiveProps (props) {
    let { flights, routes, isFetching } = props;

    let routeId = flights && flights.length ? flights[ 0 ].routeId : null;

    if (!isFetching && !this.state.selectedRoute && routes && routes.length) {
      this.setState({
        selectedRoute: this.findRouteById(routeId, routes),
        selectedTrip: this.findTripByRoute(flights),
      });
      // let flight = selectors.flights.getFlightByRouteId(flights, routeId);
      // this.props.actions.changeActivePassenger(
      //   SeatsScreenController.changePassenger(flight.passengers)
      // );
    }
    if (!isFetching && !routes) {
      this.props.actions.getRoutes();
    }
  }

  setSubmitData = child => {
    if (this && child) {
      if (!this.state.submitData) this.setState({ submitData: child.submitData });
    }
  };

  render () {
    const { selectedRoute, selectedTrip, editOpened, submitData } = this.state;
    const { routes, activePassenger, general } = this.props;
    if (!selectedRoute && !routes) {
      return <ProgressBarCenter />;
    }

    return (
      <Navigation
        submitData={submitData}
        screen={
          <ScreenDetection
            mobileScreen={
              <SeatsMobileScreen
                showDate
                routes={routes}
                openEditPassenger={this.openEditPassenger}
                closeEditPassenger={this.closeEditPassenger}
                editOpened={editOpened}
                selectedPassenger={activePassenger}
                selectedTrip={selectedTrip}
                selectedRoute={selectedRoute}
                toggleRoutes={this.toggleRoutes}
                flights={this.props.flights}
                general={general}
                routeId={selectedRoute ? selectedRoute.id : ''}
                ref={this.setSubmitData}
                submitFlights={this.props.actions.submitFlights}
              />
            }
            desktopScreen={
              <SeatsDesktopScreen
                showDate
                routes={routes}
                openEditPassenger={this.openEditPassenger}
                closeEditPassenger={this.closeEditPassenger}
                editOpened={editOpened}
                selectedPassenger={activePassenger}
                selectedTrip={selectedTrip}
                selectedRoute={selectedRoute}
                toggleRoutes={this.toggleRoutes}
                flights={this.props.flights}
                general={general}
                routeId={selectedRoute ? selectedRoute.id : ''}
                ref={this.setSubmitData}
                submitFlights={this.props.actions.submitFlights}
              />
            }
          />
        }
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatsScreen);



// WEBPACK FOOTER //
// ./src/containers/seats/SeatsScreen.js